import angular from 'angular';
import vendor from './vendor';
import directive from './vendors.directive';
import controller from './vendors.controller';

export default angular.module('app.components.advisory.enterpriseModeling.vendors', [
  vendor
])
  .directive('emVendors', directive)
  .controller('EMVendorsController', controller)
  .name;

console.log('app.components.advisory.enterpriseModeling.vendors created');
